module.exports = __webpack_public_path__ + "img/fronx-boostergreen-tittle.8711423d.svg";